import { render } from "./PageRelocalisationSurface.vue?vue&type=template&id=ee98d3ee"
import script from "./PageRelocalisationSurface.vue?vue&type=script&lang=js"
export * from "./PageRelocalisationSurface.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__